import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/stex-toast.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { CartProvider } from "./Context/CartContext";
import { AuthProvider } from "./Context/AuthContext";
import { GlobalProvider } from "./GlobalContext/GlobalContext";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import CartSyncOnLogin from "./Components/CartSyncOnLogin";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <GlobalProvider>
          <CartProvider>
            <AuthProvider>
              <CartSyncOnLogin />
              <App />
            </AuthProvider>
          </CartProvider>
        </GlobalProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
